/* @flow */

import * as React from 'react';
import './footer-bar.css';

type Props = {
    left?: React.Node,
    center?: React.Node,
    right?: React.Node,
    hasBorder?: boolean,
};

FooterBar.defaultProps = {
    left: <div />,
    center: null,
    right: <div />,
};

export function FooterBar(props: Props) {
    return (
        <div styleName={props.hasBorder ? 'footer-bar--bordered' : 'footer-bar'}>
            {props.left}
            {props.center}
            {props.right}
        </div>
    );
}
